export default "__VITE_ASSET__3b25fec9__"